import axios from "axios";
import SERVER from '@/API/url';

const EnCodingStore = {
    namespaced: true,
    state: {
        
    },
    getters: {

    },
    mutations: {

    },
    actions: {
        // encoding
        encoding: ({commit}, params) => { 
            
            return new Promise((resolve, reject) => {
                axios.get(SERVER.URL + '/api/Device/GetEucKr?text='+params.text,
                { 
                    headers: {
                        ...SERVER.HEADERS,
                    }
                }
                ).then(res => {
                    //console.log(res);
                    resolve(res.data);
                })
                .catch(err => {
                    console.log(err.message);
                    reject(err.message);
                });
            })
        },

        // encoding2
        encoding2: ({commit}, params) => { 
            
            return new Promise((resolve, reject) => {
                axios.get(SERVER.URL + '/api/Device/GetEucKr2?text='+params.text,
                { 
                    headers: {
                        ...SERVER.HEADERS,
                    }
                }
                ).then(res => {
                    //console.log(res);
                    resolve(res.data);
                })
                .catch(err => {
                    console.log(err.message);
                    reject(err.message);
                });
            })
        },

        //파일업로드, URL return API
        fileUploadRtnURL: ({ commit }, params) => {
            return new Promise((resolve, reject) => {
                // console.log("params: ",params)
                axios
                    .post(SERVER.URL + `/api/File/upload?filepath=${params.filepath}`, params.file, {
                        headers: {
                            // 'Content-Type': 'multipart/form-data',
                            ...SERVER.HEADERS,
                        },
                    })
                    .then((res) => {
                        // console.log(res);
                        resolve(res.data);
                    })
                    .catch((err) => {
                        console.log(err.message);
                        reject(err.message);
                    });
            });
        },
    }
}

export default EnCodingStore